import React from 'react';
import { NavLink } from 'react-router-dom';
import SiteContentContext from '../../content/SiteContentContext';
import { getTranslations } from '../../content/siteContentUtils';

class Banner extends React.Component {
    static contextType = SiteContentContext;

    render() {
        const content = this.context?.content || {};
        const t = getTranslations(content);
        const homeLabel = t?.common?.home || "Anasayfa";
        const showOverlay = this.props.showOverlay !== false;

        return (
            <>
                <div
                    className={`sx-bnr-inr overlay-wraper ${this.props.className || ''}`.trim()}
                    style={{
                        backgroundImage: 'url(' + this.props.bgimage + ')',
                        backgroundPosition: 'inherit',
                        backgroundSize: 'initial',
                        backgroundAttachment: 'initial',
                    }}
                >
                    {showOverlay ? <div className="overlay-main bg-black opacity-07" /> : null}
                    <div className="container">
                        <div className="sx-bnr-inr-entry">
                            <div className="banner-title-outer">
                                <div className="banner-title-name">
                                    <h2 className="m-tb0">{this.props.title}</h2>                                <p>
                                        {this.props.description}
                                    </p>
                                </div>
                            </div>
                            {/* BREADCRUMB ROW */}
                            <div>
                                <ul className="sx-breadcrumb breadcrumb-style-2">
                                <li><NavLink to={"/"}>{homeLabel}</NavLink></li>
                                    <li>{this.props.pagename}</li>
                                </ul>
                            </div>
                            {/* BREADCRUMB ROW END */}
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Banner;
